// extracted by mini-css-extract-plugin
export default {"editor":"WysiwygTextArea_editor__D9nrX"};